import classNames from "classnames";

import { ChevronBackwardIcon } from "@jti/brand-icons/chevron-backward";
import { ChevronForwardIcon } from "@jti/brand-icons/chevron-forward";

import styles from "./Chevron.module.scss";

type ChevronProps = {
  className?: string;
  disabled?: boolean;
  orientation?: "up" | "down" | "left" | "right";
};

export const Chevron = ({ orientation, className }: ChevronProps) => {
  const cn = classNames(styles.chevron, className);
  if (orientation === "left") return <ChevronBackwardIcon className={cn} width={"24px"} height={"24px"} />;
  if (orientation === "right") return <ChevronForwardIcon className={cn} width={"24px"} height={"24px"} />;
  return <span />;
};
